<h1 mat-dialog-title>
{{title}}</h1>
<div mat-dialog-content>
  @if (subTitle) {
    <div class="subtitle">{{subTitle}}</div>
  }
  @if (msg) {
    <div class="msg">
      {{msg}}
    </div>
  }
  @if (exception) {
    <div class="exception">
      <pre>{{exceptionText}}</pre>
    </div>
  }
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial i18n="@@error-dialog.button.confirm">Ok</button>
</div>
